/**
 * component-table-scroll.js
 * SH Updated: February 2026 - Always-visible branded scrollbar with OverlayScrollbars
 *
 * Wraps tables in scrollable containers with OverlayScrollbars (always visible).
 */
function initTableScroll() {
  var selectors = Array.prototype.slice.call(arguments);
  var OS = window.OverlayScrollbarsGlobal && window.OverlayScrollbarsGlobal.OverlayScrollbars;
  if (!selectors.length || !OS) return;

  selectors.forEach(function(selector) {
    var containers = document.querySelectorAll(selector);
    containers.forEach(function(container) {
      var tables = container.querySelectorAll('table');
      tables.forEach(function(table) {
        if (table.parentElement.classList.contains('table-scroll-wrapper')) return;

        var wrapper = document.createElement('div');
        wrapper.className = 'table-scroll-wrapper';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);

        OS(wrapper, {
          overflow: { x: 'scroll', y: 'hidden' },
          scrollbars: { theme: 'os-theme-dark', autoHide: 'never' }
        });
      });
    });
  });
}
